import baseService from "@common/externos/services/base.service";
import store from "@common/store/store";

const tbRoute = window.api_routes.smarAPD_Tributario_Domain;
const commonRoute = window.api_routes.smarAPD_Common;

let http = baseService(store, tbRoute);

const apiDef = {
  save(tokenRecaptcha, data) {
    return http.post(
      "/ParametroValorExterno/CrachaAmbulante/Emitir",
      tokenRecaptcha,
      data
    );
  }
};

export default apiDef;
